export const pxToEm = (px: number): `${number}em` => {
  return `${pxToEmValue(px)}em`;
};

export const pxToEmValue = (px: number): number => {
  const PX_EM_RATIO = 16;
  return px / PX_EM_RATIO;
};
